import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GEO_REGION_ACTIVE_LIST } from "./apiRoutes";

export interface GeoRegionItem {
  id: string;
  name: string;
}

export interface GeoRegionListResponse {
  data: {
    records: GeoRegionItem[];
  }[];
}

const fetchActiveGeoRegions = async () => {
  const response = await axiosAuth.get(GEO_REGION_ACTIVE_LIST);
  return response.data as GeoRegionListResponse;
};

export const useGetActiveGeoRegions = (
  queryParams?: UseQueryOptions<GeoRegionListResponse, Error, GeoRegionListResponse, [string]>
) =>
  useQuery<GeoRegionListResponse, Error, GeoRegionListResponse, [string]>({
    queryKey: ["geo-regions-active"],
    queryFn: fetchActiveGeoRegions,
    ...(queryParams as any),
  });


